export const HOME = '/';
export const LOGIN = '/login';
export const VERSION = '/version';

export const ADMIN = '/admin';

export const REPORT_DETAIL = '/report/:placeCode';
export const REPORT_DETAIL_AND_ACTION = '/report/:placeCode:action';
export const USER_DETAIL = '/admin/user/:userId';
export const INACTIVE_USER = '/inactive-user';
